import { useContext, useEffect, useMemo, useState } from 'react';
import Slider from '@mui/material/Slider';
import { Card, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { MyContext } from './MyContext';

import { alpha, styled, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getUrl } from './productsAccount';
import ContactForm from './contactForm';
import { currencyFormat } from './utils';

export default function Interface() {
  const {
    canvasRef,
    setCanvasImg,
    handleOpen,
    counter1visible,
    setcounter1visible,
    counter2visible,
    setcounter2visible,
    Lightmode,
    setLightmode,
    width,
    setwidth,
    length,
    setlength,
    height,
    setsetheight,
    numerofwalls,
    setnumerofwalls,
    numerofcabins,
    setnumerofcabins,
    numberofcounters,
    setnumberofcounters,
    bigcabin,
    setbigcabin,
    splitwall,
    setsplitwall,
    counterdata,
    setcounterdata,
    setCart,
    cart,
    storeData,
    setStoreData,
    getUnit,
    currency,
    showPrice,
    showWallsLabels,
    currencyMultiplier,
    otherData,
    wallsData,
    isLoading,
    collectCartData,
    panels1,
    panels2,
    setPanels1,
    setPanels2,
    setFeetsCount,
    setBendersCount,
    showRequestButton,
    unitSystem,
  } = useContext(MyContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [update, setUpdate] = useState(0);

  useEffect(() => {
    collectCartData();
  }, [
    width,
    height,
    length,
    numberofcounters,
    numerofcabins,
    numberofcounters,
    splitwall,
    numerofwalls,
    update,
  ]);

  function handleCart() {
    const url = getUrl(cart, storeData);
    window.open(url, '_blank');
  }

  function handleRequestOffer() {
    setCanvasImg(canvasRef.current?.toDataURL() || '');
    handleOpen();
  }

  function Updatewidth(e) {
    if (!e || !e.target || !e.target.value) return;
    setwidth(e.target.value);

    collectCartData();
  }

  function Updatelength(e) {
    if (!e || !e.target || !e.target.value) return;
    setlength(e.target.value);

    collectCartData();
  }

  function Updateheight(e) {
    if (!e || !e.target || !e.target.value) return;
    setsetheight(e.target.value);

    collectCartData();
  }

  function Updatewallsnumber(e) {
    setnumerofwalls(e.target.value);
  }

  function Updatecabinsnumber(e) {
    setnumerofcabins(e.target.value);
  }

  function UpdateCounternumber(e) {
    setnumberofcounters(e.target.value);
  }

  function UpdateLight(e) {
    setLightmode(e.target.checked);
  }

  function UpdateCabin(e) {
    setbigcabin(e.target.checked);

    collectCartData();
  }

  function UpdateSplitWall(e) {
    setsplitwall(e.target.checked);

    collectCartData();
  }

  function MinusNumberofwall() {
    if (numerofwalls > 1) {
      setnumerofwalls(numerofwalls - 1);
      collectCartData();
    }
  }

  function PlusNumberofwall() {
    if (numerofwalls < 3) {
      setnumerofwalls(numerofwalls + 1);
      collectCartData();
    }
  }

  function MinusNumberofCabin() {
    if (numerofcabins > 0) {
      setnumerofcabins(numerofcabins - 1);
    }

    collectCartData();
  }

  function PlusNumberofCabin() {
    if (numerofcabins < 1) {
      if (numerofwalls > 1) {
        setnumerofcabins(numerofcabins + 1);
      }
    }

    collectCartData();
  }

  function MinusNumberCounter() {
    if (numberofcounters > 0) {
      setnumberofcounters(numberofcounters - 1);
    }

    collectCartData();
  }

  function PlusNumberCounter() {
    if (numberofcounters < 2) {
      setnumberofcounters(numberofcounters + 1);
    }

    if (numerofwalls == 2 && width == 3 && length == 3 && numerofcabins == 1) {
      // setnumberofcounters(1);
    }

    collectCartData();
  }

  const widthmarks = [
    {
      value: 1,
    },
    {
      value: 2,
    },
    {
      value: 3,
    },
    {
      value: 4,
    },

    {
      value: 5,
    },

    {
      value: 6,
    },
  ];

  const lengthmarks = [
    {
      value: 1,
    },
    {
      value: 2,
    },
    {
      value: 3,
    },
    {
      value: 4,
    },

    {
      value: 5,
    },

    {
      value: 6,
    },
  ];

  const heightmarks = [
    {
      value: 2,
    },
    {
      value: 2.25,
    },
    {
      value: 2.5,
    },
  ];

  useEffect(() => {
    if (counterdata[0] == true && counterdata[1] == false) {
      // setnumberofcounters(1);
    }


    if (counterdata[0] == false) {
      setnumberofcounters(0);
    }
  }, [counterdata]);

  const PrettoSlider = styled(Slider)({
    color: '#0A0A0A',
    height: 4,
    '& .MuiSlider-track': {
      border: 'none',
    },
    '& .MuiSlider-thumb': {
      height: 33,
      width: 33,
      backgroundColor: '#fff',
      boxShadow: '0 3px 9px rgba(0,0,0,0.25)',
      border: '3px solid currentColor',
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: '0 3px 9px rgba(0,0,0,0.25)',
      },
      '&:before': {
        display: 'none',
      },
    },
    '& .MuiSlider-valueLabel': {
      lineHeight: 1.2,
      fontSize: 12,
      background: 'unset',
      padding: 0,
      width: 33,
      height: 33,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: '#0A0A0A',
      transformOrigin: 'bottom left',
      transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
      '&:before': { display: 'none' },
      '&.MuiSlider-valueLabelOpen': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
      },

      '& > *': {
        transform: 'rotate(45deg)',
      },
    },
    '& .MuiSlider-mark': {
      backgroundColor: '#A2A2A2',
      height: 11,
      width: 3,
      borderRadius: 12,

      '&.MuiSlider-markActive': {
        opacity: 1,
        backgroundColor: 'currentColor',
      },
    },
  });

  const BootstrapButtonOutlined = styled(Button)({
    marginTop: 5,
    boxShadow: 'none',
    width: '100%',
    height: '48px',
    color: '#0A0A0A',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    borderRadius: 50,
    lineHeight: 1.5,
    backgroundColor: '#fff',
    border: 'solid 2px #0A0A0A',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#0A0A0A',
      color: '#fff',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0A0A0A',
      borderColor: '#005cbf',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  });

  const BootstrapButton = styled(Button)({
    boxShadow: 'none',
    width: '100%',
    height: '48px',
    color: '#fff',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    borderRadius: 50,
    lineHeight: 1.5,
    backgroundColor: '#0A0A0A',
    borderColor: '#0A0A0A',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      backgroundColor: '#0A0A0A',
      borderColor: '#0A0A0A',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0A0A0A',
      borderColor: '#005cbf',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  });

  const BlackSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: 'black',
      '&:hover': {
        backgroundColor: alpha(grey[600], theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'black',
    },
  }));

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 56,
    height: 32,

    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(12px) translateY(2px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      transform: 'translateX(2px) translateY(2px)',
      '&.Mui-checked': {
        transform: 'translateX(24px) translateY(2px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor:
            theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 24,
      height: 24,
      borderRadius: 50,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 32 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255,255,255,.35)'
          : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  }));

  const totalPrice = useMemo(() => {
    const total = cart.reduce((total, item) => total + item.price, 0);

    return currencyFormat(total) + ` ${currency || '$'}`;
  }, [cart, currency, update]);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: isMobile ? 'auto' : 20,
        right: isMobile ? 0 : 20,
        left: isMobile ? '50%' : 'auto',
        transform: isMobile ? 'translate(-50%,0%)' : 'auto',
        bottom: isMobile ? 0 : 'auto',

        zIndex: 100,
        minWidth: isMobile ? '100vw' : 410,
        maxWidth: isMobile ? '100vw' : 380,
      }}
    >
      <Card
        variant='outlined'
        sx={{
          maxHeight: isMobile ? 380 : 'auto',
          overflowY: 'scroll',
          padding: 2.5,
          paddingTop: 2.5,
          paddingBottom: 2.5,
          borderRadius: 3.5,
        }}
      >
        <Box sx={{ marginBottom: 1.4 }}>
          <Typography sx={{ fontSize: 17 }} gutterBottom>{`Width: ${getUnit(
            width
          )}`}</Typography>

          <PrettoSlider
            sx={{ marginBottom: 1.5 }}
            valueLabelDisplay='auto'
            aria-label='pretto slider'
            marks={widthmarks}
            min={1}
            max={6}
            onChange={e => Updatewidth(e)}
            value={width}
            defaultValue={width}
          />

          <Typography sx={{ fontSize: 17 }} gutterBottom>{`length:  ${getUnit(
            length
          )} `}</Typography>
          <PrettoSlider
            sx={{ marginBottom: 1.5 }}
            valueLabelDisplay='auto'
            aria-label='pretto slider'
            value={length}
            marks={lengthmarks}
            min={1}
            max={6}
            onChange={e => Updatelength(e)}
          />

          <Typography sx={{ fontSize: 17 }} gutterBottom>{`Height:  ${getUnit(
            height
          )}`}</Typography>

          {unitSystem !== 'in' && (
            <PrettoSlider
              sx={{ marginBottom: 0.5 }}
              valueLabelDisplay='auto'
              aria-label='pretto slider'
              value={height}
              step={0.25}
              marks={heightmarks}
              min={2}
              max={2.5}
              onChange={e => Updateheight(e)}
            />
          )}
        </Box>
        <Box sx={{ minWidth: 120 }}>
          {/* Walls dropdown */}

          <div className='section-options-container'>
            <div className='width-number-section'>
              <p>Walls</p>

              <div className='width-text-container'>
                <i
                  class='width-minus-btn bi bi-dash'
                  onClick={() => MinusNumberofwall()}
                ></i>
                <h1>{numerofwalls}</h1>
                <i
                  class='width-plus-btn bi bi-plus'
                  onClick={() => PlusNumberofwall()}
                ></i>
              </div>
            </div>

            <div className='width-number-section'>
              <p>Cabin</p>

              <div className='width-text-container'>
                <i
                  class='width-minus-btn bi bi-dash'
                  onClick={() => MinusNumberofCabin()}
                ></i>
                <h1>{numerofcabins}</h1>
                <i
                  class='width-plus-btn bi bi-plus'
                  onClick={() => PlusNumberofCabin()}
                ></i>
              </div>
            </div>

            <div className='width-number-section'>
              <p>Counter</p>

              <div className='width-text-container'>
                <i
                  class='width-minus-btn bi bi-dash'
                  onClick={() => MinusNumberCounter()}
                ></i>
                <h1>{numberofcounters}</h1>
                <i
                  class='width-plus-btn bi bi-plus'
                  onClick={() => PlusNumberCounter()}
                ></i>
              </div>
            </div>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Stack
            sx={{ marginTop: 2 }}
            direction='column'
            spacing={1}
            alignItems='center'
          >
            <Typography sx={{ fontSize: 14.5 }}>
              Do you want to have a small or a big cabin?
            </Typography>
            <Switch
              color='default'
              value={bigcabin}
              onChange={e => UpdateCabin(e)}
              defaultChecked
            />
          </Stack>

          <Stack
            sx={{ marginTop: 3 }}
            direction='column'
            spacing={1}
            alignItems='center'
          >
            <Typography sx={{ fontSize: 14 }}>
              Do you want to split the stand into 1m wide walls?
            </Typography>
            <Switch
              color='default'
              value={splitwall}
              onChange={e => UpdateSplitWall(e)}
              defaultChecked
            />
          </Stack>

          <Stack
            sx={{ marginTop: 0, marginBottom: 1.4 }}
            direction='column'
            spacing={1}
            alignItems='center'
          >
            <Typography sx={{ fontSize: 14 }} display={'block'}>
              Glow
            </Typography>
            <Switch
              color='default'
              value={Lightmode}
              onChange={e => UpdateLight(e)}
              defaultChecked
            />
          </Stack>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          <Stack display={showPrice ? 'block' : 'none'}>
            <Typography fontSize={14} fontWeight={500}>
              Price: {showPrice}
            </Typography>
            <Typography fontSize={40} fontWeight={700}>
              {isLoading ? <CircularProgress /> : totalPrice}
            </Typography>
          </Stack>
        </Box>

        <ContactForm />
        <BootstrapButton onClick={handleCart} disabled={isLoading}>
          {isLoading ? <CircularProgress /> : 'ADD TO CART'}
        </BootstrapButton>

        <Box display={showRequestButton ? 'block' : 'none'}>
          <BootstrapButtonOutlined
            onClick={handleRequestOffer}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress /> : 'OFFER REQUEST'}
          </BootstrapButtonOutlined>
        </Box>
      </Card>
    </Box>
  );
}
